import React from "react";
import { Form, Button, Input, Select } from "antd";

import "./SpinsFilter.scss";
import { ReactSVG } from "react-svg";
const SpinsFilterForm = ({
	filterSubmit,
	form,
	resetForm,
	spinGames,
	gamesLoading,
	spinRewards,
	rewardsLoading,
	onExportClick,
}) => {
	return (
		<div className="spins-filter-form-container">
			<Form form={form} onFinish={filterSubmit} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item name="game_id">
						<Select placeholder="Game" loading={gamesLoading}>
							<Select.Option value="">Select Game</Select.Option>
							{spinGames &&
								spinGames.data.data.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item name="reward_id">
						<Select placeholder="Reward" loading={rewardsLoading}>
							<Select.Option value="">Select Reward</Select.Option>
							{spinRewards &&
								spinRewards.data.data.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item name="email">
						<Input />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="text" onClick={resetForm} className="btn btn-secondary">
						Reset
					</Button>
					<Button
						type="text"
						className="btn btn-secondary btn-export"
						onClick={onExportClick}
					>
						Download
						<ReactSVG src="/icons/file-download.svg" />
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						Search
						<ReactSVG src="/icons/search.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default SpinsFilterForm;
